import { render } from "./InventoryTMS.vue?vue&type=template&id=c31d7d46&scoped=true&ts=true"
import script from "./InventoryTMS.vue?vue&type=script&lang=ts"
export * from "./InventoryTMS.vue?vue&type=script&lang=ts"

import "./InventoryTMS.vue?vue&type=style&index=0&id=c31d7d46&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c31d7d46"]])

export default __exports__